import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingDairyManureAdditive, getFootprintingDairyManureAdditiveAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_DAIRY_MANURE_ADDITIVE } from "consts";

export const useGetFootprintingDairyManureAdditive = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_DAIRY_MANURE_ADDITIVE, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingDairyManureAdditiveAdmin(primaryDataId ?? "") : getFootprintingDairyManureAdditive(primaryDataId ?? "")),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
